@for (outletName of outletNames; track outletName; let i = $index) {
  <app-blade [ngClass]="'blade' + (i+1)" [name]="outletName" [bladeIndex]="i"></app-blade>
}